import AboutUsModule from 'components/about-us/AboutUsModule';
import AboutUsSiteContainer from 'components/about-us/AboutUsSiteContainer';
import { useIsMobile } from 'hooks/ui/useIsMobile';

import { TrustpilotCarouselWidget } from '../TrustpilotCarouselWidget';
import styles from './TrustpilotSection.module.css';

export const TrustpilotSection = (props: { variant?: 'HomePage2026' }) => {
  const { isMobile } = useIsMobile();
  return (
    <AboutUsModule background={'grey'}>
      <AboutUsSiteContainer>
        <div
          className={`${styles.container} ${styles.trustpilotSection} ${props.variant === 'HomePage2026' ? styles.containerHomePage2026 : ''}`}
        >
          {props.variant === 'HomePage2026' ? (
            isMobile ? (
              <div className={styles.headingText}>
                <p className="daymadeTypographyTaglineAccent">On Trustpilot</p>
                <h2 className={'daymadeTypographyXL'}>Rated ‘Excellent’</h2>
              </div>
            ) : undefined
          ) : (
            <h2 className={`aboutUsTypographyHeaderXlarge ${styles.title}`}>
              <span className={styles.titleLine}>Rated</span>
              <span className={styles.titleLine}>{" 'Excellent'"}</span>
              <span className={`${styles.titleLine} ${styles.lastLine}`}>
                {' on Trustpilot'}
              </span>
            </h2>
          )}
          <TrustpilotCarouselWidget />
        </div>
      </AboutUsSiteContainer>
    </AboutUsModule>
  );
};
